webpackJsonp([47],{

/***/ 2408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryView_vue__ = __webpack_require__(3506);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bef806d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryView_vue__ = __webpack_require__(4054);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4044)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bef806d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistoryView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bef806d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistoryView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/ClinicHistoryView.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0bef806d", Component.options)
  } else {
    hotAPI.reload("data-v-0bef806d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__ = __webpack_require__(1274);
/* harmony default export */ __webpack_exports__["a"] = ({methods:{goToSection:function goToSection(path){var needsPatientId=!this.$store.getters['session/userIsPatient']&&this.$route.query.patientId;var route={path:''+__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["d" /* BASE_PATH */]+(path!==__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["P" /* MENU_PATH */]?'/'+path:''),query:{}};if(needsPatientId)route.query.patientId=this.$route.query.patientId;if(this.$route.query.petId)route.query.petId=this.$route.query.petId;this.$router.push(route).catch(function(){});}},data:function data(){return{historyReadOnly:!!sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */])};},watch:{items:function items(value){this.$emit('anyItemSelected',value&&value.length>0);},zeroItems:function zeroItems(value){this.$emit('anyItemSelected',value);}}});

/***/ }),

/***/ 2477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__ = __webpack_require__(2556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__ = __webpack_require__(2604);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2602)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/AddButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38b0fcd7", Component.options)
  } else {
    hotAPI.reload("data-v-38b0fcd7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-button',
  props: {
    buttonText: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('add-btn');
      }
    },
    showTextOnMobile: Boolean
  },
  computed: {
    btnText: function btnText() {
      return this.$uiHelpers.isMobile && !this.showTextOnMobile ? '' : this.buttonText;
    }
  },
  data: function data() {
    return {
      hover: false
    };
  }
});

/***/ }),

/***/ 2582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
var api=function api(){return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;};/* harmony default export */ __webpack_exports__["a"] = ({getDiseasesByName:function getDiseasesByName(_ref){var name=_ref.name,onlyCIE=_ref.onlyCIE,specialtyId=_ref.specialtyId,hideLoadingIcon=_ref.hideLoadingIcon;return api().get('diseases',{params:{name:name,specialtyId:specialtyId,onlyCIE:onlyCIE},loading:!hideLoadingIcon});},getProfDiseases:function getProfDiseases(_ref2){var name=_ref2.name,hideLoadingIcon=_ref2.hideLoadingIcon;return api().get('professional/diseases',{params:{name:name},loading:!hideLoadingIcon});},getCenterDiseases:function getCenterDiseases(_ref3){var name=_ref3.name,hideLoadingIcon=_ref3.hideLoadingIcon;return api().get('center/diseases',{params:{name:name},loading:!hideLoadingIcon});}});

/***/ }),

/***/ 2602:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("18c0739d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2603:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("icon-button", {
    attrs: {
      icon: "/static-appopensalud/img/icons/morillas-svg-icons/primary/add.svg",
      text: _vm.btnText
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b0fcd7", esExports)
  }
}

/***/ }),

/***/ 2622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_ui_BaseCard_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-allergies-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__["a" /* default */],
        BaseCard: __WEBPACK_IMPORTED_MODULE_5__components_base_ui_BaseCard_vue__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_8__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    data: function data() {
        return {
            items: [],
            showAddSection: false,
            zeroItems: null,
            table: {
                fields: [{
                    label: this.$t('description-column'),
                    key: this.$i18nHelpers.normalizeProp('entity.name')
                }, {
                    label: this.$t('gravity-ph'),
                    key: this.$i18nHelpers.normalizeProp('severity.name')
                }, {
                    label: '',
                    key: 'remove'
                }],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            select: {
                options: [],
                value: null,
                loading: false
            },
            severitySelect: {
                options: [],
                value: null,
                loading: false
            },
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["l" /* RED_COLOUR */]
        };
    },

    computed: {
        stacked: function stacked() {
            return window.innerWidth < 500;
        },
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])();
        },
        showZeroBox: function showZeroBox() {
            return !this.items.length;
        }
    },
    methods: {
        toggleZeroBox: function toggleZeroBox() {
            this.clinicHistoryRepository.saveHistoryAllergy({
                noAllergies: this.zeroItems
            });
        },
        load: function load() {
            var _this = this;

            this.loading = true;
            this.clinicHistoryRepository.getHistoryAllergies().then(function (response) {
                var data = response.data.data;
                if (data.length && data[0].noAllergies) {
                    _this.zeroItems = true;
                    return;
                }
                _this.items = data;
                _this.loading = false;
            });
            this.clinicHistoryRepository.getSeverities().then(function (response) {
                _this.severitySelect.options = response.data.data;
            });
        },
        loadSelectOptions: function loadSelectOptions(search) {
            var _this2 = this;

            if (search) {
                this.select.loading = true;
                this.clinicHistoryRepository.getAllergiesByName(search).then(function (response) {
                    _this2.select.options = response.data.data;
                    _this2.select.loading = false;
                });
            }
        },
        save: function save() {
            var _this3 = this;

            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('allergySelectError'));
                return;
            }
            if (!this.severitySelect.value) {
                this.$store.dispatch('showInfoAlert', this.$t('allergySeveritySelectError'));
                return;
            }
            this.clinicHistoryRepository.saveHistoryAllergy({
                diseaseId: this.select.value,
                severityId: this.severitySelect.value
            }).then(function (response) {
                var data = response.data;
                if (data && data.status === 200) {
                    _this3.items.unshift(data.data);
                }
                _this3.select.value = null;
                _this3.severitySelect.value = null;
                _this3.select.options = [];
            });
        },
        remove: function remove(data) {
            var _this4 = this;

            var id = data.item.id;
            this.clinicHistoryRepository.deleteHistoryAllergy(id).then(function (response) {
                if (response.data.data) {
                    _this4.items = _this4.items.filter(function (item) {
                        return item.id !== id;
                    });
                }
            });
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_ui_BaseCard_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-med-allergies-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__["a" /* default */],
        BaseCard: __WEBPACK_IMPORTED_MODULE_5__components_base_ui_BaseCard_vue__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_8__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    computed: {
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])();
        },
        stacked: function stacked() {
            return window.innerWidth < 500;
        },
        showZeroBox: function showZeroBox() {
            return !this.items.length;
        }
    },
    data: function data() {
        return {
            items: [],
            showAddSection: false,
            zeroItems: null,
            table: {
                fields: [{
                    label: this.$t('description-column'),
                    key: 'name'
                }, {
                    label: this.$t('gravity-ph'),
                    key: 'severityName'
                }, {
                    label: '',
                    key: 'remove'
                }],
                filters: {
                    specialtyId: null
                }
            },
            select: {
                options: [],
                value: null,
                loading: false
            },
            severitySelect: {
                options: [],
                value: null,
                loading: false
            },
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["l" /* RED_COLOUR */]
        };
    },

    methods: {
        toggleZeroBox: function toggleZeroBox() {
            this.clinicHistoryRepository.saveHistoryMedAllergies({
                noMedsAllergies: this.zeroItems
            });
        },
        load: function load() {
            var _this = this;

            this.severitySelect.loading = true;
            this.clinicHistoryRepository.getHistoryMedAllergies().then(function (response) {
                var data = response.data.data;
                if (data.length && data[0].noMedsAllergies) {
                    _this.zeroItems = true;
                    return;
                }
                _this.items = data;
            });
            this.clinicHistoryRepository.getSeverities().then(function (response) {
                _this.severitySelect.options = response.data.data;
                _this.severitySelect.loading = false;
            });
        },
        loadSelectOptions: function loadSelectOptions(search) {
            var _this2 = this;

            if (search) {
                this.select.loading = true;
                this.clinicHistoryRepository.getMedAllergiesByName(search).then(function (response) {
                    _this2.select.options = response.data.data;
                    _this2.select.loading = false;
                });
            }
        },
        save: function save() {
            var _this3 = this;

            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('medicationSelectError'));
                return;
            }
            if (!this.severitySelect.value) {
                this.$store.dispatch('showInfoAlert', this.$t('allergySeveritySelectError'));
                return;
            }
            this.clinicHistoryRepository.saveHistoryMedAllergies({
                dcsa: this.select.value,
                severityId: this.severitySelect.value
            }).then(function (response) {
                var data = response.data;
                if (data && data.status === 200) {
                    _this3.items.unshift(data.data);
                }
                _this3.select.value = null;
                _this3.severitySelect.value = null;
                _this3.select.options = [];
            });
        },
        remove: function remove(data) {
            var _this4 = this;

            var id = data.item.id;
            this.clinicHistoryRepository.deleteHistoryAllergy(id).then(function (response) {
                if (response.data.data) {
                    _this4.items = _this4.items.filter(function (item) {
                        return item.id !== id;
                    });
                }
            });
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_filters__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_forms_BaseDatepicker_vue__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repositories_DiseasesRepository__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-diseases-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__["a" /* default */],
        BaseDatepicker: __WEBPACK_IMPORTED_MODULE_7__base_forms_BaseDatepicker_vue__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_10__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    data: function data() {
        return {
            items: [],
            showAddSection: false,
            zeroItems: null,
            table: {
                fields: [{
                    label: this.$t('description-column'),
                    key: this.$i18nHelpers.normalizeProp('entity.name')
                }, {
                    label: this.$t('date'),
                    key: 'date',
                    formatter: function formatter(value, key, item) {
                        return value ? __WEBPACK_IMPORTED_MODULE_5__plugins_filters__["a" /* default */].beautifySimpleDate(value) : '-';
                    },
                    sortable: true
                }, {
                    label: '',
                    key: 'remove'
                }],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            select: {
                options: [],
                value: null,
                loading: false
            },
            diseaseDate: null,
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["l" /* RED_COLOUR */]
        };
    },

    computed: {
        stacked: function stacked() {
            return window.innerWidth < 500;
        },
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])();
        },
        showZeroBox: function showZeroBox() {
            return !this.items.length;
        }
    },
    methods: {
        toggleZeroBox: function toggleZeroBox() {
            this.clinicHistoryRepository.saveHistoryDisease({
                noDiseases: this.zeroItems
            });
        },
        load: function load() {
            var _this = this;

            this.loading = true;
            this.clinicHistoryRepository.getHistoryDiseases().then(function (response) {
                var data = response.data.data;
                if (data.length && data[0].noDiseases) {
                    _this.zeroItems = true;
                    return;
                }
                _this.items = data;
                _this.loading = false;
            });
        },
        loadSelectOptions: function loadSelectOptions(search) {
            var _this2 = this;

            if (search) {
                this.select.loading = true;
                __WEBPACK_IMPORTED_MODULE_9__repositories_DiseasesRepository__["a" /* default */].getDiseasesByName({ name: search, onlyCIE: true, hideLoadingIcon: true }).then(function (response) {
                    _this2.select.options = response.data.data;
                    _this2.select.loading = false;
                });
            }
        },
        save: function save() {
            var _this3 = this;

            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('diseaseselecterror'));
                return;
            }
            this.clinicHistoryRepository.saveHistoryDisease({
                diseaseId: this.select.value,
                date: this.diseaseDate
            }).then(function (response) {
                var data = response.data;
                if (data && data.status === 200) {
                    _this3.items.unshift(data.data);
                }
                _this3.diseaseDate = null;
                _this3.select.value = null;
                _this3.select.options = [];
            });
        },
        remove: function remove(data) {
            var _this4 = this;

            var id = data.item.id;
            this.clinicHistoryRepository.deleteHistoryDisease(id).then(function (response) {
                if (response.data.data) {
                    _this4.items = _this4.items.filter(function (item) {
                        return item.id !== id;
                    });
                }
            });
        },
        setShowAddSection: function setShowAddSection() {
            this.showAddSection = true;
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_filters__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_forms_BaseDatepicker_vue__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-chrondiseases-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__["a" /* default */],
        BaseDatepicker: __WEBPACK_IMPORTED_MODULE_7__base_forms_BaseDatepicker_vue__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_9__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    data: function data() {
        return {
            items: [],
            showAddSection: false,
            zeroItems: null,
            table: {
                fields: [{
                    label: this.$t('description-column'),
                    key: this.$i18nHelpers.normalizeProp('entity.name')
                }, {
                    label: this.$t('date'),
                    key: 'date',
                    formatter: function formatter(value, key, item) {
                        return value ? __WEBPACK_IMPORTED_MODULE_5__plugins_filters__["a" /* default */].beautifySimpleDate(value) : '-';
                    },
                    sortable: true
                }, {
                    label: '',
                    key: 'remove'
                }],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            select: {
                options: [],
                value: null,
                loading: false
            },
            diseaseDate: null,
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["l" /* RED_COLOUR */]
        };
    },

    computed: {
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])();
        },
        stacked: function stacked() {
            return window.innerWidth < 500;
        },
        showZeroBox: function showZeroBox() {
            return !this.items.length;
        }
    },
    methods: {
        toggleZeroBox: function toggleZeroBox() {
            this.clinicHistoryRepository.saveHistoryChronDisease({
                noChronicDiseases: this.zeroItems
            });
        },
        load: function load() {
            var _this = this;

            this.loading = true;
            this.clinicHistoryRepository.getHistoryChrondiseases().then(function (response) {
                var data = response.data.data;
                if (data.length && data[0].noChronicDiseases) {
                    _this.zeroItems = true;
                    return;
                }
                _this.items = data;
                _this.loading = false;
            });
            this.clinicHistoryRepository.getChronDiseasesByName().then(function (response) {
                _this.select.options = response.data.data;
                _this.select.loading = false;
            });
        },
        loadSelectOptions: function loadSelectOptions(search) {
            var _this2 = this;

            if (search) {
                this.select.loading = true;
                this.clinicHistoryRepository.getChronDiseasesByName(search).then(function (response) {
                    _this2.select.options = response.data.data;
                    _this2.select.loading = false;
                });
            }
        },
        save: function save() {
            var _this3 = this;

            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('diseaseselecterror'));
                return;
            }
            this.clinicHistoryRepository.saveHistoryChronDisease({
                diseaseId: this.select.value,
                date: this.diseaseDate
            }).then(function (response) {
                var data = response.data;
                if (data && data.status === 200) {
                    _this3.items.unshift(data.data);
                }
                _this3.diseaseDate = null;
                _this3.select.value = null;
            });
        },
        remove: function remove(data) {
            var _this4 = this;

            var id = data.item.id;
            this.clinicHistoryRepository.deleteHistoryChronDisease(id).then(function (response) {
                if (response.data.data) {
                    _this4.items = _this4.items.filter(function (item) {
                        return item.id !== id;
                    });
                }
            });
        },
        setShowAddSection: function setShowAddSection() {
            this.showAddSection = true;
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_filters__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_forms_BaseDatepicker_vue__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-vaccines-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__["a" /* default */],
        BaseDatepicker: __WEBPACK_IMPORTED_MODULE_7__base_forms_BaseDatepicker_vue__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        stacked: function stacked() {
            return window.innerWidth < 500;
        },
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])();
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_9__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    data: function data() {
        return {
            vaccines: [],
            showAddSection: false,
            table: {
                fields: [{
                    label: this.$t('description-column'),
                    key: 'name'
                }, {
                    label: this.$t('commercial-name-column'),
                    key: 'commercialName'
                }, {
                    label: this.$t('date'),
                    key: 'date',
                    formatter: function formatter(value, key, item) {
                        return value ? __WEBPACK_IMPORTED_MODULE_5__plugins_filters__["a" /* default */].beautifySimpleDate(value) : '-';
                    },
                    sortable: true
                }, {
                    label: '',
                    key: 'remove'
                }],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            select: {
                options: [],
                value: null,
                loading: false
            },
            selectLabs: {
                options: [],
                value: null,
                loading: false
            },
            vaccineDate: null,
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["l" /* RED_COLOUR */]
        };
    },

    methods: {
        load: function load() {
            var _this = this;

            this.loading = true;
            this.clinicHistoryRepository.getHistoryVaccinations().then(function (response) {
                _this.vaccines = response.data.data;
                _this.loading = false;
            });
            if (this.select.options.length === 0) {
                this.clinicHistoryRepository.getAllVaccines().then(function (response) {
                    _this.select.options = response.data.data;
                    _this.select.loading = false;
                });
            }
        },
        save: function save() {
            var _this2 = this;

            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('vaccineSelectError'));
                return;
            }
            this.clinicHistoryRepository.saveHistoryVaccination({
                vacineId: this.select.value,
                date: this.vaccineDate,
                vacineLab: this.selectLabs.value
            }).then(function (response) {
                var data = response.data;
                if (data && data.status === 200) {
                    _this2.vaccines.unshift(data.data);
                }
                _this2.vaccineDate = null;
                _this2.select.value = null;
                _this2.selectLabs.value = null;
            });
        },
        vaccineSelected: function vaccineSelected() {
            var _this3 = this;

            if (this.select.value) {
                this.selectLabs.value = null;
                this.selectLabs.loading = true;
                this.clinicHistoryRepository.getVaccineLabs(this.select.value).then(function (response) {
                    var data = response.data.data;
                    if (data) {
                        _this3.selectLabs.options = data;
                        _this3.selectLabs.loading = false;
                    }
                });
            }
        },
        remove: function remove(data) {
            var _this4 = this;

            var id = data.item.id;
            this.clinicHistoryRepository.deleteHistoryVaccination(id).then(function (response) {
                if (response.data.data) {
                    _this4.vaccines = _this4.vaccines.filter(function (item) {
                        return item.id !== id;
                    });
                }
            });
        },
        setShowAddSection: function setShowAddSection() {
            this.showAddSection = true;
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_BaseDialog__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_filters__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_forms_BaseDatepicker_vue__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_forms_BaseCheckbox_vue__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var I18N_FILE = 'clinic-history';
var MEDICATION_REMINDER_PATH = '/patient/clinic-history/medication-reminder';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-medicines-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_5__components_base_buttons_AddButton__["a" /* default */],
        BaseDatepicker: __WEBPACK_IMPORTED_MODULE_8__base_forms_BaseDatepicker_vue__["default"],
        BaseCheckbox: __WEBPACK_IMPORTED_MODULE_9__base_forms_BaseCheckbox_vue__["default"],
        BaseDialog: __WEBPACK_IMPORTED_MODULE_1__components_base_BaseDialog__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        },
        past: Boolean,
        hideReminderDialog: Boolean
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_11__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    computed: {
        stacked: function stacked() {
            return window.innerWidth < 810;
        },
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_2__repositories_ClinicHistoryRepository__["a" /* default */])();
        },
        showZeroBox: function showZeroBox() {
            return !this.items.length;
        }
    },
    data: function data() {
        return {
            items: [],
            zeroItems: null,
            showAddSection: false,
            currentlyTakeMed: false,
            tableKey: 1,
            medicationReminder: {
                show: false,
                id: null,
                code: null,
                created: false
            },
            showReminderCreateDialog: false,
            table: {
                fields: [{
                    label: this.$t('description-column'),
                    key: this.$i18nHelpers.normalizeProp('entity.name')
                }, {
                    label: this.$t('dateStart'),
                    key: 'dateStart',
                    formatter: function formatter(value, key, item) {
                        return value ? __WEBPACK_IMPORTED_MODULE_6__plugins_filters__["a" /* default */].beautifySimpleDate(value) : '-';
                    },
                    sortable: true
                }, {
                    label: this.$t('dateEnd'),
                    key: 'dateEnd',
                    formatter: function formatter(value, key, item) {
                        return value ? __WEBPACK_IMPORTED_MODULE_6__plugins_filters__["a" /* default */].beautifySimpleDate(value) : '-';
                    },
                    sortable: true
                }, {
                    label: '',
                    key: 'actionsMobile',
                    class: 'table-actions'
                }, {
                    label: '',
                    key: 'currentlyNoTakeMed',
                    hiddenStacked: true
                }, {
                    label: '',
                    key: 'reminder',
                    hiddenStacked: true
                }, {
                    label: '',
                    key: 'removeReminder',
                    hiddenStacked: true
                }, {
                    label: '',
                    key: 'remove',
                    hiddenStacked: true
                }],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            select: {
                options: [],
                value: null,
                loading: false
            },
            medicationDate: null,
            medicationEndDate: null,
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_7__constants_colours__["l" /* RED_COLOUR */],
            GREEN_COLOUR: __WEBPACK_IMPORTED_MODULE_7__constants_colours__["h" /* GREEN_COLOUR */]
        };
    },

    methods: {
        stopMedication: function stopMedication(data) {
            var _this = this;

            this.clinicHistoryRepository.stopHistoryMedication({
                medicationId: data.item.id
            }).then(function (response) {
                if (response.data.data) {
                    _this.load();
                }
            });
        },
        toggleZeroBox: function toggleZeroBox() {
            this.clinicHistoryRepository.saveHistoryMedication({
                noMedicines: this.zeroItems
            });
        },
        showNoTakeMedSelector: function showNoTakeMedSelector(dateEnd) {
            return !dateEnd || new Date(dateEnd) > new Date();
        },
        load: function load() {
            var _this2 = this;

            this.loading = true;
            this.clinicHistoryRepository.getHistoryMedications({ past: this.past }).then(function (response) {
                var data = response.data.data;
                if (data.length && data[0].noMedicines) {
                    _this2.zeroItems = true;
                    return;
                }
                _this2.items = data;
                _this2.loading = false;
                _this2.tableKey++;
            });
        },
        loadSelectOptions: function loadSelectOptions(search) {
            var _this3 = this;

            if (search) {
                this.select.loading = true;
                this.clinicHistoryRepository.getMedicinesByName(search).then(function (response) {
                    _this3.select.options = response.data.data;
                    _this3.select.loading = false;
                });
            }
        },
        save: function save() {
            var _this4 = this;

            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('medicationSelectError'));
                return;
            }
            if (this.medicationDate && this.medicationEndDate && new Date(this.medicationEndDate) < new Date(this.medicationDate)) {
                this.$store.dispatch('showInfoAlert', this.$t('medicationEndDateMinorStartDate'));
                return;
            }
            this.clinicHistoryRepository.saveHistoryMedication({
                medicationId: this.select.value,
                dateStart: this.medicationDate,
                dateEnd: this.medicationEndDate
            }).then(function (response) {
                var data = response.data;
                if (data && data.status === 200) {
                    _this4.items.unshift(data.data);
                    _this4.medicationReminder.id = data.data.id;
                    _this4.medicationReminder.code = _this4.select.value;
                    if (!_this4.hideReminderDialog) {
                        _this4.showReminderCreateDialog = true;
                    }
                }
                _this4.medicationDate = null;
                _this4.medicationEndDate = null;
                _this4.select.value = null;
                _this4.select.options = [];
            });
        },
        createMedicationReminder: function createMedicationReminder(code) {
            this.$router.push(MEDICATION_REMINDER_PATH + '/' + (code || this.medicationReminder.code));
        },
        removeReminder: function removeReminder(id) {
            var _this5 = this;

            Object(__WEBPACK_IMPORTED_MODULE_2__repositories_ClinicHistoryRepository__["a" /* default */])().deleteMedicationReminder(id).then(function (response) {
                var data = response.data.data;
                if (data) {
                    _this5.load();
                } else {
                    _this5.$store.dispatch('showDangerAlert', _this5.$t('error.try-again'));
                }
            });
        },
        remove: function remove(data) {
            var _this6 = this;

            var id = data.item.id;
            this.clinicHistoryRepository.deleteHistoryMedication(id).then(function (response) {
                if (response.data.data) {
                    _this6.load();
                }
            });
        },
        setShowAddSection: function setShowAddSection() {
            this.showAddSection = true;
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_ui_BaseCard__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_filters__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'appointment-history',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"],
        BaseCard: __WEBPACK_IMPORTED_MODULE_3__components_base_ui_BaseCard__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        stacked: function stacked() {
            return window.innerWidth < 810;
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_clinicHistory_mixin__["a" /* default */]],
    data: function data() {
        return {
            appointments: [],
            filters: __WEBPACK_IMPORTED_MODULE_4__plugins_filters__["a" /* default */],
            table: {
                fields: [{
                    label: this.$t('reason-column'),
                    key: this.$i18nHelpers.normalizeProp('disease.name')
                }, {
                    label: this.$t('speciality-column'),
                    key: this.$i18nHelpers.normalizeProp('speciality.name')
                }, {
                    label: this.$t('type'),
                    key: this.$i18nHelpers.normalizeProp('consultationType.name')
                }, {
                    label: this.$t('date'),
                    key: 'date',
                    formatter: function formatter(value, key, item) {
                        return __WEBPACK_IMPORTED_MODULE_4__plugins_filters__["a" /* default */].beautifySimpleDateTime(value);
                    }
                }, {
                    label: '',
                    key: 'preview'
                }],
                filters: {
                    specialtyId: null
                }
            },
            specialtyOptions: [],
            loading: false
        };
    },

    methods: {
        load: function load() {
            var _this = this;

            this.loading = true;
            Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])().getAppointments(this.table.filters.specialtyId).then(function (response) {
                _this.appointments = response.data.data;
                _this.specialtyOptions = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["sortBy"])(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["uniqBy"])(_this.appointments.map(function (item) {
                    return item.speciality;
                }), 'id'), function (item) {
                    return _this.$i18nHelpers.normalize(item.name);
                });
                _this.loading = false;
            });
        },
        goAppointment: function goAppointment(id) {
            this.$store.getters['session/userIsProfessional'] ? this.$helpers.goToProfessionalWebApp('appointments/preview/' + id, this.$apiToken) : this.$store.getters['session/userIsCenter'] ? this.$helpers.goToCenterWebApp('appointments/preview/' + id, this.$apiToken) : this.$helpers.goToPatientWebApp('appointments/preview/' + id, this.$apiToken);
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_ui_BaseCard_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repositories_DiseasesRepository__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-familybackgrounds-section',
    components: {
        PaginatedTable: __WEBPACK_IMPORTED_MODULE_0__components_base_PaginatedTable__["a" /* default */],
        BaseSelect: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseSelect__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
        AddButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_AddButton__["a" /* default */],
        BaseCard: __WEBPACK_IMPORTED_MODULE_5__components_base_ui_BaseCard_vue__["default"]
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_9__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    computed: {
        stacked: function stacked() {
            return window.innerWidth < 500;
        },
        clinicHistoryRepository: function clinicHistoryRepository() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__repositories_ClinicHistoryRepository__["a" /* default */])();
        }
    },
    data: function data() {
        return {
            backgrounds: [],
            showAddSection: false,
            table: {
                fields: [{
                    label: this.$t('description-column'),
                    key: this.$i18nHelpers.normalizeProp('entity.name')
                }, {
                    label: this.$t('relationship'),
                    key: this.$i18nHelpers.normalizeProp('relationshipType.name')
                }, {
                    label: '',
                    key: 'remove'
                }],
                filters: {
                    specialtyId: null
                }
            },
            loading: false,
            select: {
                options: [],
                value: null,
                loading: false
            },
            relationshipSelect: {
                options: [],
                value: null,
                loading: false
            },
            RED_COLOUR: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["l" /* RED_COLOUR */]
        };
    },

    methods: {
        load: function load() {
            var _this = this;

            this.loading = true;
            this.clinicHistoryRepository.getHistoryFamilyBackgrounds().then(function (response) {
                _this.backgrounds = response.data.data;
                _this.loading = false;
            });
            this.clinicHistoryRepository.getHistoryFamilyRelationships().then(function (response) {
                _this.relationshipSelect.options = response.data.data;
            });
        },
        loadSelectOptions: function loadSelectOptions(search) {
            var _this2 = this;

            if (search) {
                this.select.loading = true;
                __WEBPACK_IMPORTED_MODULE_8__repositories_DiseasesRepository__["a" /* default */].getDiseasesByName({ name: search, onlyCIE: true, hideLoadingIcon: true }).then(function (response) {
                    _this2.select.options = response.data.data;
                    _this2.select.loading = false;
                });
            }
        },
        save: function save() {
            var _this3 = this;

            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('familyHistorySelectError'));
                return;
            }
            if (!this.relationshipSelect.value) {
                this.$store.dispatch('showInfoAlert', this.$t('relationshipSelectError'));
                return;
            }
            this.clinicHistoryRepository.saveHistoryFamilyBackgrounds({
                diseaseId: this.select.value,
                relationshipTypeId: this.relationshipSelect.value
            }).then(function (response) {
                var data = response.data;
                if (data && data.status === 200) {
                    _this3.backgrounds.unshift(data.data);
                }
                _this3.select.value = null;
                _this3.relationshipSelect.value = null;
                _this3.select.options = [];
            });
        },
        remove: function remove(data) {
            var _this4 = this;

            var id = data.item.id;
            this.clinicHistoryRepository.deleteHistoryFamilyBackgrounds(id).then(function (response) {
                if (response.data.data) {
                    _this4.backgrounds = _this4.backgrounds.filter(function (item) {
                        return item.id !== id;
                    });
                }
            });
        }
    },
    created: function created() {
        this.load();
    }
});

/***/ }),

/***/ 2702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryAllergiesSection_vue__ = __webpack_require__(2622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b232913e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryAllergiesSection_vue__ = __webpack_require__(2705);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2703)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryAllergiesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b232913e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryAllergiesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryAllergiesSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b232913e", Component.options)
  } else {
    hotAPI.reload("data-v-b232913e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2703:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("e7ed19c0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b232913e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryAllergiesSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b232913e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryAllergiesSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2704:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("otherAllergies")))]),
      _vm._v(" "),
      _vm.showZeroBox
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      on: { change: _vm.toggleZeroBox },
                      model: {
                        value: _vm.zeroItems,
                        callback: function($$v) {
                          _vm.zeroItems = $$v
                        },
                        expression: "zeroItems"
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("noOtherAllergies"))
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.zeroItems
        ? _c(
            "base-card",
            {
              attrs: {
                overflowVisible: "",
                hideNeuCardClass: "",
                hideButtons: _vm.historyReadOnly,
                showRightBtn: ""
              },
              on: {
                rightBtnClick: function($event) {
                  _vm.showAddSection = true
                }
              }
            },
            [
              !_vm.showAddSection
                ? _c(
                    "template",
                    {
                      slot:
                        _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                          ? "append-btn-title"
                          : "right-button"
                    },
                    [_c("add-button")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAddSection
                ? _c("div", { staticClass: "row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-6 col-12 p-1" },
                      [
                        _c("base-select", {
                          attrs: {
                            clearable: "",
                            searchable: "",
                            loading: _vm.select.loading,
                            options: _vm.select.options,
                            label: _vm.$i18nHelpers.normalizeProp("name"),
                            valueProp: "id",
                            placeholder: _vm.$t("allergy-ph")
                          },
                          on: {
                            search: function($event) {
                              return _vm.loadSelectOptions($event)
                            }
                          },
                          model: {
                            value: _vm.select.value,
                            callback: function($$v) {
                              _vm.$set(_vm.select, "value", $$v)
                            },
                            expression: "select.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-12 p-1" },
                      [
                        _c("base-select", {
                          attrs: {
                            options: _vm.severitySelect.options,
                            searchable: "",
                            loading: _vm.severitySelect.loading,
                            label: _vm.$i18nHelpers.normalizeProp("name"),
                            valueProp: "id"
                          },
                          model: {
                            value: _vm.severitySelect.value,
                            callback: function($$v) {
                              _vm.$set(_vm.severitySelect, "value", $$v)
                            },
                            expression: "severitySelect.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-2 col-12 p-1" },
                      [
                        _c("base-button", { on: { click: _vm.save } }, [
                          _vm._v(_vm._s(_vm.$t("save")))
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("paginated-table", {
                attrs: {
                  fields: _vm.table.fields,
                  items: _vm.items,
                  "empty-text": _vm.$t("noallergy"),
                  stacked: _vm.stacked
                },
                scopedSlots: _vm._u(
                  [
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(remove)",
                          fn: function(data) {
                            return [
                              _c("base-icon", {
                                staticClass: "clickable",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                  color: _vm.RED_COLOUR
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.remove(data)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.stacked
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "clickable",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.remove(data)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("remove")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.stacked ? _c("hr") : _vm._e()
                            ]
                          }
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b232913e", esExports)
  }
}

/***/ }),

/***/ 2706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryMedAllergiesSection_vue__ = __webpack_require__(2623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2e6d6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryMedAllergiesSection_vue__ = __webpack_require__(2709);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2707)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryMedAllergiesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b2e6d6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryMedAllergiesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryMedAllergiesSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b2e6d6e", Component.options)
  } else {
    hotAPI.reload("data-v-5b2e6d6e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2707:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2708);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("59995ddc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b2e6d6e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryMedAllergiesSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b2e6d6e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryMedAllergiesSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2708:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("allergies")))]),
      _vm._v(" "),
      _vm.showZeroBox
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      on: { change: _vm.toggleZeroBox },
                      model: {
                        value: _vm.zeroItems,
                        callback: function($$v) {
                          _vm.zeroItems = $$v
                        },
                        expression: "zeroItems"
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("noMedAllergies"))
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.zeroItems
        ? _c(
            "base-card",
            {
              attrs: {
                overflowVisible: "",
                hideNeuCardClass: "",
                hideButtons: _vm.historyReadOnly,
                showRightBtn: ""
              },
              on: {
                rightBtnClick: function($event) {
                  _vm.showAddSection = true
                }
              }
            },
            [
              !_vm.showAddSection
                ? _c(
                    "template",
                    {
                      slot:
                        _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                          ? "append-btn-title"
                          : "right-button"
                    },
                    [_c("add-button")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAddSection
                ? _c("div", { staticClass: "row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-6 col-12 p-1" },
                      [
                        _c("base-select", {
                          attrs: {
                            clearable: "",
                            searchable: "",
                            loading: _vm.select.loading,
                            options: _vm.select.options,
                            label: "name",
                            valueProp: "id",
                            placeholder: _vm.$t("medication-ph")
                          },
                          on: {
                            search: function($event) {
                              return _vm.loadSelectOptions($event)
                            }
                          },
                          model: {
                            value: _vm.select.value,
                            callback: function($$v) {
                              _vm.$set(_vm.select, "value", $$v)
                            },
                            expression: "select.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-12 p-1" },
                      [
                        _c("base-select", {
                          attrs: {
                            options: _vm.severitySelect.options,
                            searchable: "",
                            loading: _vm.severitySelect.loading,
                            label: _vm.$i18nHelpers.normalizeProp("name"),
                            valueProp: "id"
                          },
                          model: {
                            value: _vm.severitySelect.value,
                            callback: function($$v) {
                              _vm.$set(_vm.severitySelect, "value", $$v)
                            },
                            expression: "severitySelect.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-2 col-12 p-1" },
                      [
                        _c("base-button", { on: { click: _vm.save } }, [
                          _vm._v(_vm._s(_vm.$t("save")))
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("paginated-table", {
                attrs: {
                  fields: _vm.table.fields,
                  items: _vm.items,
                  "empty-text": _vm.$t("noallergy"),
                  stacked: _vm.stacked
                },
                scopedSlots: _vm._u(
                  [
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(remove)",
                          fn: function(data) {
                            return [
                              _c("base-icon", {
                                staticClass: "clickable",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                  color: _vm.RED_COLOUR
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.remove(data)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.stacked
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "clickable",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.remove(data)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("remove")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.stacked ? _c("hr") : _vm._e()
                            ]
                          }
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b2e6d6e", esExports)
  }
}

/***/ }),

/***/ 2710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryDiseasesSection_vue__ = __webpack_require__(2624);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7aff38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryDiseasesSection_vue__ = __webpack_require__(2713);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2711)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryDiseasesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7aff38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryDiseasesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryDiseasesSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5e7aff38", Component.options)
  } else {
    hotAPI.reload("data-v-5e7aff38", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2711:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2712);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("36576c50", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5e7aff38\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryDiseasesSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5e7aff38\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryDiseasesSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2713:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("diseases")))]),
      _vm._v(" "),
      _vm.showZeroBox
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      on: { change: _vm.toggleZeroBox },
                      model: {
                        value: _vm.zeroItems,
                        callback: function($$v) {
                          _vm.zeroItems = $$v
                        },
                        expression: "zeroItems"
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$t("noDiseases")) }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.zeroItems
        ? _c(
            "base-card",
            {
              attrs: {
                overflowVisible: "",
                hideNeuCardClass: "",
                hideButtons: _vm.historyReadOnly,
                showRightBtn: ""
              },
              on: {
                rightBtnClick: function($event) {
                  _vm.showAddSection = true
                }
              }
            },
            [
              !_vm.showAddSection
                ? _c(
                    "template",
                    {
                      slot:
                        _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                          ? "append-btn-title"
                          : "right-button"
                    },
                    [_c("add-button")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAddSection
                ? _c("div", { staticClass: "row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-lg-6 col p-1" },
                      [
                        _c("base-select", {
                          attrs: {
                            clearable: "",
                            loading: _vm.select.loading,
                            searchable: "",
                            options: _vm.select.options,
                            label: _vm.$i18nHelpers.normalizeProp("name"),
                            valueProp: "id",
                            placeholder: _vm.$t("diseases-ph")
                          },
                          on: {
                            search: function($event) {
                              return _vm.loadSelectOptions($event)
                            }
                          },
                          model: {
                            value: _vm.select.value,
                            callback: function($$v) {
                              _vm.$set(_vm.select, "value", $$v)
                            },
                            expression: "select.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-lg-4 p-1" },
                      [
                        _c("base-datepicker", {
                          attrs: {
                            dateBeforeNow: "",
                            resetButtton: "",
                            placeholder: _vm.$t("startDate"),
                            noMarginBottom: ""
                          },
                          model: {
                            value: _vm.diseaseDate,
                            callback: function($$v) {
                              _vm.diseaseDate = $$v
                            },
                            expression: "diseaseDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-lg-2 p-1" },
                      [
                        _c("base-button", { on: { click: _vm.save } }, [
                          _vm._v(_vm._s(_vm.$t("save")))
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("paginated-table", {
                attrs: {
                  fields: _vm.table.fields,
                  noResponsive: "",
                  items: _vm.items,
                  "empty-text": _vm.$t("nodisease"),
                  stacked: _vm.stacked
                },
                scopedSlots: _vm._u(
                  [
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(remove)",
                          fn: function(data) {
                            return [
                              _c("base-icon", {
                                staticClass: "clickable",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                  color: _vm.RED_COLOUR
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.remove(data)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.stacked
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "clickable",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.remove(data)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("remove")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.stacked ? _c("hr") : _vm._e()
                            ]
                          }
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e7aff38", esExports)
  }
}

/***/ }),

/***/ 2714:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryChrondiseasesSection_vue__ = __webpack_require__(2625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e64b79c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryChrondiseasesSection_vue__ = __webpack_require__(2717);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2715)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryChrondiseasesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e64b79c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryChrondiseasesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryChrondiseasesSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e64b79c", Component.options)
  } else {
    hotAPI.reload("data-v-6e64b79c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2715:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2716);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5a427603", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6e64b79c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryChrondiseasesSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6e64b79c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryChrondiseasesSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2716:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("chrondiseases")))]),
      _vm._v(" "),
      _vm.showZeroBox
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      on: { change: _vm.toggleZeroBox },
                      model: {
                        value: _vm.zeroItems,
                        callback: function($$v) {
                          _vm.zeroItems = $$v
                        },
                        expression: "zeroItems"
                      }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("noChronDiseases"))
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.zeroItems
        ? _c(
            "base-card",
            {
              attrs: {
                overflowVisible: "",
                hideNeuCardClass: "",
                hideButtons: _vm.historyReadOnly,
                showRightBtn: ""
              },
              on: {
                rightBtnClick: function($event) {
                  _vm.showAddSection = true
                }
              }
            },
            [
              !_vm.showAddSection
                ? _c(
                    "template",
                    {
                      slot:
                        _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                          ? "append-btn-title"
                          : "right-button"
                    },
                    [_c("add-button")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAddSection
                ? _c("div", { staticClass: "row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-6 col-12 p-1" },
                      [
                        _c("base-select", {
                          attrs: {
                            searchable: "",
                            loading: _vm.select.loading,
                            options: _vm.select.options,
                            label: _vm.$i18nHelpers.normalizeProp("name"),
                            valueProp: "id",
                            placeholder: _vm.$t("diseases-ph")
                          },
                          model: {
                            value: _vm.select.value,
                            callback: function($$v) {
                              _vm.$set(_vm.select, "value", $$v)
                            },
                            expression: "select.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-12 p-1" },
                      [
                        _c("base-datepicker", {
                          attrs: {
                            dateBeforeNow: "",
                            resetButtton: "",
                            placeholder: _vm.$t("startDate"),
                            noMarginBottom: ""
                          },
                          model: {
                            value: _vm.diseaseDate,
                            callback: function($$v) {
                              _vm.diseaseDate = $$v
                            },
                            expression: "diseaseDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-2 col-12 p-1" },
                      [
                        _c("base-button", { on: { click: _vm.save } }, [
                          _vm._v(_vm._s(_vm.$t("save")))
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("paginated-table", {
                attrs: {
                  fields: _vm.table.fields,
                  items: _vm.items,
                  "empty-text": _vm.$t("nodisease"),
                  stacked: _vm.stacked
                },
                scopedSlots: _vm._u(
                  [
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(remove)",
                          fn: function(data) {
                            return [
                              _c("base-icon", {
                                staticClass: "clickable",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                  color: _vm.RED_COLOUR
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.remove(data)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.stacked
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "clickable",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.remove(data)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("remove")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.stacked ? _c("hr") : _vm._e()
                            ]
                          }
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e64b79c", esExports)
  }
}

/***/ }),

/***/ 2718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryVaccinesSection_vue__ = __webpack_require__(2626);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c19d5c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryVaccinesSection_vue__ = __webpack_require__(2721);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2719)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryVaccinesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c19d5c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryVaccinesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryVaccinesSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8c19d5c6", Component.options)
  } else {
    hotAPI.reload("data-v-8c19d5c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2719:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2720);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("6b0c27d8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8c19d5c6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryVaccinesSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8c19d5c6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryVaccinesSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2720:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-card",
    {
      attrs: {
        title: _vm.$t("vaccines"),
        overflowVisible: "",
        hideNeuCardClass: "",
        hideButtons: _vm.historyReadOnly
      },
      on: {
        rightBtnClick: function($event) {
          _vm.showAddSection = true
        }
      }
    },
    [
      !_vm.showAddSection
        ? _c(
            "template",
            {
              slot:
                _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                  ? "append-btn-title"
                  : "right-button"
            },
            [_c("add-button")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddSection
        ? _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              { staticClass: "col-lg-5 col-12 p-1" },
              [
                _c("base-select", {
                  attrs: {
                    searchable: "",
                    loading: _vm.select.loading,
                    options: _vm.select.options,
                    label: "name",
                    valueProp: "id",
                    placeholder: _vm.$t("vaccine-ph")
                  },
                  on: { input: _vm.vaccineSelected },
                  model: {
                    value: _vm.select.value,
                    callback: function($$v) {
                      _vm.$set(_vm.select, "value", $$v)
                    },
                    expression: "select.value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.select.value
              ? _c(
                  "div",
                  { staticClass: "col-lg-3 col-12 p-1" },
                  [
                    _c("base-select", {
                      attrs: {
                        searchable: "",
                        loading: _vm.selectLabs.loading,
                        options: _vm.selectLabs.options,
                        label: "name",
                        valueProp: "id",
                        placeholder: _vm.$t("vaccine-commercial-name")
                      },
                      model: {
                        value: _vm.selectLabs.value,
                        callback: function($$v) {
                          _vm.$set(_vm.selectLabs, "value", $$v)
                        },
                        expression: "selectLabs.value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-4 col-12 p-1" },
              [
                _c("base-datepicker", {
                  attrs: {
                    dateBeforeNow: "",
                    resetButtton: "",
                    noMarginBottom: ""
                  },
                  model: {
                    value: _vm.vaccineDate,
                    callback: function($$v) {
                      _vm.vaccineDate = $$v
                    },
                    expression: "vaccineDate"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-2 col-12 p-1" },
              [
                _c("base-button", { on: { click: _vm.save } }, [
                  _vm._v(_vm._s(_vm.$t("save")))
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("paginated-table", {
        attrs: {
          fields: _vm.table.fields,
          items: _vm.vaccines,
          "empty-text": _vm.$t("novaccine"),
          stacked: _vm.stacked
        },
        scopedSlots: _vm._u(
          [
            !_vm.historyReadOnly
              ? {
                  key: "cell(remove)",
                  fn: function(data) {
                    return [
                      _c("base-icon", {
                        staticClass: "clickable",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                          color: _vm.RED_COLOUR
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.remove(data)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.stacked
                        ? _c(
                            "span",
                            {
                              staticClass: "clickable",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.remove(data)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("remove")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stacked ? _c("hr") : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c19d5c6", esExports)
  }
}

/***/ }),

/***/ 2722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryMedicinesSection_vue__ = __webpack_require__(2627);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332779b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryMedicinesSection_vue__ = __webpack_require__(2725);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2723)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-332779b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryMedicinesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_332779b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryMedicinesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryMedicinesSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-332779b4", Component.options)
  } else {
    hotAPI.reload("data-v-332779b4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2723:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2724);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("ce3e70f0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-332779b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryMedicinesSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-332779b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryMedicinesSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2724:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-332779b4]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-332779b4],.slide-down-leave-active[data-v-332779b4]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-332779b4],.slide-down-leave-to[data-v-332779b4]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-332779b4],.slide-fade-left-leave-active[data-v-332779b4]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-332779b4],.slide-fade-left-leave-to[data-v-332779b4]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-332779b4]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-332779b4],.fade-leave-to[data-v-332779b4]{opacity:0\n}\n.checkbox-med[data-v-332779b4]{text-align:center;margin-top:auto;margin-bottom:auto\n}\n.bell-reminder[data-v-332779b4]{cursor:pointer;color:#6AEF89\n}\n.bell-slash-reminder[data-v-332779b4]{cursor:pointer;color:#FF7061\n}\n.blue[data-v-332779b4]{color:#3238C4\n}\n", ""]);

// exports


/***/ }),

/***/ 2725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(
          _vm._s(
            _vm.past ? _vm.$t("pastMedication") : _vm.$t("currentMedication")
          )
        )
      ]),
      _vm._v(" "),
      _vm.showZeroBox
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "base-checkbox",
                    {
                      on: { change: _vm.toggleZeroBox },
                      model: {
                        value: _vm.zeroItems,
                        callback: function($$v) {
                          _vm.zeroItems = $$v
                        },
                        expression: "zeroItems"
                      }
                    },
                    [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$t("noMedicines")) }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.zeroItems
        ? _c(
            "base-card",
            {
              attrs: {
                overflowVisible: "",
                hideNeuCardClass: "",
                hideButtons: _vm.historyReadOnly,
                showRightBtn: ""
              },
              on: {
                rightBtnClick: function($event) {
                  _vm.showAddSection = true
                }
              }
            },
            [
              !_vm.showAddSection && !_vm.past
                ? _c(
                    "template",
                    {
                      slot:
                        _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                          ? "append-btn-title"
                          : "right-button"
                    },
                    [_c("add-button")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAddSection
                ? _c("div", { staticClass: "row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-8 col-12 p-1" },
                      [
                        _c("base-select", {
                          attrs: {
                            clearable: "",
                            searchable: "",
                            loading: _vm.select.loading,
                            options: _vm.select.options,
                            label: "name",
                            valueProp: "id",
                            placeholder: _vm.$t("medication-ph")
                          },
                          on: {
                            search: function($event) {
                              return _vm.loadSelectOptions($event)
                            }
                          },
                          model: {
                            value: _vm.select.value,
                            callback: function($$v) {
                              _vm.$set(_vm.select, "value", $$v)
                            },
                            expression: "select.value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-12 p-1 checkbox-med" },
                      [
                        _c(
                          "base-checkbox",
                          {
                            attrs: { noMargin: "" },
                            on: {
                              input: function() {
                                return (_vm.medicationEndDate = null)
                              }
                            },
                            model: {
                              value: _vm.currentlyTakeMed,
                              callback: function($$v) {
                                _vm.currentlyTakeMed = $$v
                              },
                              expression: "currentlyTakeMed"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("currentlyTakeMed")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-12 p-1" },
                      [
                        _c("base-datepicker", {
                          attrs: {
                            dateBeforeNow: "",
                            resetButtton: "",
                            placeholder: _vm.$t("startDate"),
                            noMarginBottom: ""
                          },
                          model: {
                            value: _vm.medicationDate,
                            callback: function($$v) {
                              _vm.medicationDate = $$v
                            },
                            expression: "medicationDate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.currentlyTakeMed
                      ? _c(
                          "div",
                          { staticClass: "col-lg-4 col-12 p-1" },
                          [
                            _c("base-datepicker", {
                              attrs: {
                                resetButtton: "",
                                placeholder: _vm.$t("endDate"),
                                noMarginBottom: ""
                              },
                              model: {
                                value: _vm.medicationEndDate,
                                callback: function($$v) {
                                  _vm.medicationEndDate = $$v
                                },
                                expression: "medicationEndDate"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-2 col-12 p-1" },
                      [
                        _c("base-button", { on: { click: _vm.save } }, [
                          _vm._v(_vm._s(_vm.$t("save")))
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("paginated-table", {
                key: _vm.tableKey,
                attrs: {
                  fields: _vm.table.fields,
                  items: _vm.items,
                  "empty-text": _vm.$t("nodrug"),
                  stacked: _vm.stacked
                },
                scopedSlots: _vm._u(
                  [
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(currentlyNoTakeMed)",
                          fn: function(data) {
                            return [
                              _vm.showNoTakeMedSelector(data.item.dateEnd)
                                ? _c(
                                    "base-checkbox",
                                    {
                                      attrs: { noMargin: "" },
                                      on: {
                                        input: function() {
                                          return _vm.stopMedication(data)
                                        }
                                      },
                                      model: {
                                        value: data.item.currentlyNoTakeMed,
                                        callback: function($$v) {
                                          _vm.$set(
                                            data.item,
                                            "currentlyNoTakeMed",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "data.item.currentlyNoTakeMed"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("currentlyNoTakeMed"))
                                      )
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("currentlyNoTakeMed")))
                                  ])
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(reminder)",
                          fn: function(data) {
                            return [
                              _c("b-icon-bell-fill", {
                                class: {
                                  "bell-reminder": true,
                                  blue: data.item.recurrenceReminderId
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.createMedicationReminder(
                                      data.item.code
                                    )
                                  }
                                }
                              })
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(removeReminder)",
                          fn: function(data) {
                            return [
                              data.item.recurrenceReminderId
                                ? _c("b-icon-bell-slash-fill", {
                                    staticClass: "bell-slash-reminder",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.removeReminder(data.item.id)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(remove)",
                          fn: function(data) {
                            return [
                              _c("base-icon", {
                                staticClass: "clickable",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                  color: _vm.RED_COLOUR
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.remove(data)
                                  }
                                }
                              })
                            ]
                          }
                        }
                      : null,
                    !_vm.historyReadOnly
                      ? {
                          key: "cell(actionsMobile)",
                          fn: function(data) {
                            return [
                              _c(
                                "div",
                                { staticClass: "mb-2 d-block" },
                                [
                                  _vm.showNoTakeMedSelector(data.item.dateEnd)
                                    ? _c(
                                        "base-checkbox",
                                        {
                                          attrs: { noMargin: "" },
                                          on: {
                                            input: function() {
                                              return _vm.stopMedication(data)
                                            }
                                          },
                                          model: {
                                            value: data.item.currentlyNoTakeMed,
                                            callback: function($$v) {
                                              _vm.$set(
                                                data.item,
                                                "currentlyNoTakeMed",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "data.item.currentlyNoTakeMed"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("currentlyNoTakeMed"))
                                          )
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("currentlyNoTakeMed"))
                                        )
                                      ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-2" },
                                [
                                  _c("b-icon-bell-fill", {
                                    class: {
                                      "bell-reminder": true,
                                      blue: data.item.recurrenceReminderId
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.createMedicationReminder(
                                          data.item.code
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              data.item.recurrenceReminderId
                                ? _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    [
                                      _c("b-icon-bell-slash-fill", {
                                        staticClass: "bell-slash-reminder",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.removeReminder(
                                              data.item.id
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("base-icon", {
                                    staticClass: "clickable",
                                    attrs: {
                                      src:
                                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                                      color: _vm.RED_COLOUR
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.remove(data)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr")
                            ]
                          }
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("wantAddReminderMed"),
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          okFn: function() {
            return _vm.createMedicationReminder()
          },
          cancelFn: function() {
            return (_vm.showReminderCreateDialog = false)
          }
        },
        model: {
          value: _vm.showReminderCreateDialog,
          callback: function($$v) {
            _vm.showReminderCreateDialog = $$v
          },
          expression: "showReminderCreateDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-332779b4", esExports)
  }
}

/***/ }),

/***/ 2749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseCard_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseCard: __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseCard_vue__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton__["default"]
    },
    props: {
        title: String,
        hideTitleOnOpen: Boolean,
        overflowVisible: Boolean,
        defaultOpened: Boolean,
        hideButtons: Boolean,
        accessBtnUrl: String,
        healthVarsKey: String,
        sideBarTrigger: Number,
        hideViewBtn: Boolean,
        sectionPath: String,
        color: String,
        sameTab: Boolean
    },
    created: function created() {
        if (this.defaultOpened) {
            this.opened = true;
        }
    },
    data: function data() {
        return {
            opened: false
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_clinicHistory_mixin__["a" /* default */]],
    methods: {
        toggleView: function toggleView() {
            if (this.hideViewBtn && (this.accessBtnUrl || this.sectionPath)) {
                this.sectionPath ? this.goToSection(this.sectionPath) : this.accessBtnAction(this.accessBtnUrl);
            } else {
                this.opened = !this.opened;
            }
        },
        accessBtnAction: function accessBtnAction(route) {
            if (this.sameTab) {
                this.$router.push(route);
            } else {
                window.open(route, '_blank');
            }
        },
        closeCard: function closeCard() {
            this.opened = false;
        }
    },
    computed: {
        hideTitle: function hideTitle() {
            return !this.title || this.hideTitleOnOpen && this.opened;
        },
        btnTitle: function btnTitle() {
            return !this.opened ? this.$t('watch') : this.$t('close');
        },
        showBtnLeft: function showBtnLeft() {
            return this.$uiHelpers.isMobile || this.$uiHelpers.isTablet;
        },
        openBtnVisible: function openBtnVisible() {
            return !this.opened && !this.hideViewBtn;
        }
    },
    watch: {
        sideBarTrigger: function sideBarTrigger(newValue, OldValue) {
            this.opened = true;
        },
        opened: function opened(val) {
            if (val) {
                this.$emit('opened');
            } else {
                this.$emit('closed');
            }
        }
    }
});

/***/ }),

/***/ 2758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentHistory_vue__ = __webpack_require__(2664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16b9569f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentHistory_vue__ = __webpack_require__(2761);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2759)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16b9569f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/AppointmentHistory.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-16b9569f", Component.options)
  } else {
    hotAPI.reload("data-v-16b9569f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2759:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2760);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("09e61665", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-16b9569f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AppointmentHistory.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-16b9569f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AppointmentHistory.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2760:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-select", {
        staticClass: "w-md-25 w-sm-100 mb-4",
        attrs: {
          loading: false,
          options: _vm.specialtyOptions,
          label: _vm.$i18nHelpers.normalizeProp("name"),
          valueProp: "id",
          placeholder: _vm.$t("filterSpe")
        },
        on: {
          change: function($event) {
            return _vm.load()
          }
        },
        model: {
          value: _vm.table.filters.specialtyId,
          callback: function($$v) {
            _vm.$set(_vm.table.filters, "specialtyId", $$v)
          },
          expression: "table.filters.specialtyId"
        }
      }),
      _vm._v(" "),
      _c("paginated-table", {
        attrs: {
          fields: _vm.table.fields,
          items: _vm.appointments,
          "empty-text": _vm.$t("appointment-history.not-found"),
          stacked: _vm.stacked
        },
        scopedSlots: _vm._u(
          [
            !_vm.historyReadOnly
              ? {
                  key: "cell(preview)",
                  fn: function(data) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goAppointment(data.item.id)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("seeappointment-btn")))]
                      ),
                      _vm._v(" "),
                      _vm.stacked ? _c("hr") : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16b9569f", esExports)
  }
}

/***/ }),

/***/ 2762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryFamilybackgroundsSection_vue__ = __webpack_require__(2665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e9a2b04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryFamilybackgroundsSection_vue__ = __webpack_require__(2765);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2763)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryFamilybackgroundsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e9a2b04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryFamilybackgroundsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryFamilybackgroundsSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8e9a2b04", Component.options)
  } else {
    hotAPI.reload("data-v-8e9a2b04", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2763:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2764);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5985c86c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8e9a2b04\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryFamilybackgroundsSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8e9a2b04\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryFamilybackgroundsSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2764:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-card",
    {
      attrs: {
        title: _vm.$t("familyhistory"),
        overflowVisible: "",
        hideNeuCardClass: "",
        hideButtons: _vm.historyReadOnly
      },
      on: {
        rightBtnClick: function($event) {
          _vm.showAddSection = true
        }
      }
    },
    [
      !_vm.showAddSection
        ? _c(
            "template",
            {
              slot:
                _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                  ? "append-btn-title"
                  : "right-button"
            },
            [_c("add-button")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddSection
        ? _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              { staticClass: "col-lg-6 col-12 p-1" },
              [
                _c("base-select", {
                  attrs: {
                    clearable: "",
                    searchable: "",
                    loading: _vm.select.loading,
                    options: _vm.select.options,
                    label: _vm.$i18nHelpers.normalizeProp("name"),
                    valueProp: "id",
                    placeholder: _vm.$t("familyhistory-ph")
                  },
                  on: {
                    search: function($event) {
                      return _vm.loadSelectOptions($event)
                    }
                  },
                  model: {
                    value: _vm.select.value,
                    callback: function($$v) {
                      _vm.$set(_vm.select, "value", $$v)
                    },
                    expression: "select.value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-4 col-12 p-1" },
              [
                _c("base-select", {
                  attrs: {
                    options: _vm.relationshipSelect.options,
                    searchable: "",
                    loading: _vm.relationshipSelect.loading,
                    label: _vm.$i18nHelpers.normalizeProp("name"),
                    valueProp: "id"
                  },
                  model: {
                    value: _vm.relationshipSelect.value,
                    callback: function($$v) {
                      _vm.$set(_vm.relationshipSelect, "value", $$v)
                    },
                    expression: "relationshipSelect.value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-2 col-12 p-1" },
              [
                _c("base-button", { on: { click: _vm.save } }, [
                  _vm._v(_vm._s(_vm.$t("save")))
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("paginated-table", {
        attrs: {
          fields: _vm.table.fields,
          items: _vm.backgrounds,
          "empty-text": _vm.$t("nofamilyhistory"),
          stacked: _vm.stacked
        },
        scopedSlots: _vm._u(
          [
            !_vm.historyReadOnly
              ? {
                  key: "cell(remove)",
                  fn: function(data) {
                    return [
                      _c("base-icon", {
                        staticClass: "clickable",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                          color: _vm.RED_COLOUR
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.remove(data)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.stacked
                        ? _c(
                            "span",
                            {
                              staticClass: "clickable",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.remove(data)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("remove")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stacked ? _c("hr") : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e9a2b04", esExports)
  }
}

/***/ }),

/***/ 2794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistorySectionWrapper_vue__ = __webpack_require__(2749);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc3c194_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistorySectionWrapper_vue__ = __webpack_require__(2983);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2981)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cc3c194"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClinicHistorySectionWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc3c194_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClinicHistorySectionWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/ClinicHistorySectionWrapper.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0cc3c194", Component.options)
  } else {
    hotAPI.reload("data-v-0cc3c194", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2981:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2982);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("282707f2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0cc3c194\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistorySectionWrapper.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0cc3c194\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistorySectionWrapper.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2982:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-0cc3c194]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-0cc3c194],.slide-down-leave-active[data-v-0cc3c194]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-0cc3c194],.slide-down-leave-to[data-v-0cc3c194]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-0cc3c194],.slide-fade-left-leave-active[data-v-0cc3c194]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-0cc3c194],.slide-fade-left-leave-to[data-v-0cc3c194]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-0cc3c194]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-0cc3c194],.fade-leave-to[data-v-0cc3c194]{opacity:0\n}\n.left-btn[data-v-0cc3c194]{text-align:left\n}\n@media only screen and (max-width: 575px){\n.btn[data-v-0cc3c194]{padding:.7rem 1.8rem\n}\n}\n.close-btn-history-wrapper[data-v-0cc3c194]{position:absolute;right:2rem;top:1rem\n}\n@media only screen and (max-width: 575px){\n.close-btn-history-wrapper[data-v-0cc3c194]{right:1rem;top:0.4rem\n}\n}\n@media only screen and (max-width: 575px){\n.history-wrapper-card[data-v-0cc3c194] h3{font-size:1.27rem\n}\n}\n[data-v-0cc3c194] .history-wrapper-card .neu-card-title{text-align:initial\n}\n", ""]);

// exports


/***/ }),

/***/ 2983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { clickable: !_vm.opened },
      on: {
        click: function($event) {
          !_vm.opened ? _vm.toggleView() : null
        }
      }
    },
    [
      _c(
        "base-card",
        {
          key: _vm.healthVarsKey,
          staticClass: "mb-4 history-wrapper-card",
          style: { "background-color": _vm.color, "border-color": _vm.color },
          attrs: {
            overflowVisible: _vm.overflowVisible,
            title: _vm.title,
            hideTitle: _vm.hideTitle,
            flowRoot: "",
            marginBottom: _vm.opened ? 3 : 0
          },
          scopedSlots: _vm._u(
            [
              !_vm.hideButtons & !_vm.showBtnLeft
                ? {
                    key: "right-button",
                    fn: function() {
                      return [
                        _vm.openBtnVisible
                          ? _c("base-button", [_vm._v(_vm._s(_vm.btnTitle))])
                          : _vm._e(),
                        _vm.accessBtnUrl || _vm.sectionPath
                          ? _c(
                              "base-button",
                              {
                                class: { "ml-2": _vm.openBtnVisible },
                                attrs: { white: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.sectionPath
                                      ? _vm.goToSection(_vm.sectionPath)
                                      : _vm.accessBtnAction(_vm.accessBtnUrl)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("login-wrd")))]
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          )
        },
        [
          _vm._v(" "),
          !_vm.hideButtons && _vm.showBtnLeft
            ? _c(
                "div",
                { staticClass: "left-btn mt-3" },
                [
                  _vm.openBtnVisible
                    ? _c("base-button", [_vm._v(_vm._s(_vm.btnTitle))])
                    : _vm._e(),
                  _vm.accessBtnUrl || _vm.sectionPath
                    ? _c(
                        "base-button",
                        {
                          class: { "ml-2": _vm.openBtnVisible },
                          attrs: { white: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.sectionPath
                                ? _vm.goToSection(_vm.sectionPath)
                                : _vm.accessBtnAction(_vm.accessBtnUrl)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("login-wrd")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideButtons && _vm.opened
            ? _c(
                "button",
                {
                  staticClass: "close close-btn-history-wrapper",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.closeCard.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.opened ? _vm._t("default") : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cc3c194", esExports)
  }
}

/***/ }),

/***/ 3506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_clinicHistory_ClinicHistorySectionWrapper__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_AppointmentHistory_vue__ = __webpack_require__(2758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_HistoryAllergiesSection_vue__ = __webpack_require__(2702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_HistoryMedAllergiesSection_vue__ = __webpack_require__(2706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_HistoryDiseasesSection_vue__ = __webpack_require__(2710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_HistoryChrondiseasesSection_vue__ = __webpack_require__(2714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_HistoryVaccinesSection_vue__ = __webpack_require__(2718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_HistoryMedicinesSection_vue__ = __webpack_require__(2722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_HistoryFamilybackgroundsSection_vue__ = __webpack_require__(2762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_HistoryObservationsSection_vue__ = __webpack_require__(4046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_HistoryEventsSection_vue__ = __webpack_require__(4050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_layout_mixin__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        HistoryWrapper: __WEBPACK_IMPORTED_MODULE_0__components_views_clinicHistory_ClinicHistorySectionWrapper__["a" /* default */],
        AppointmentHistory: __WEBPACK_IMPORTED_MODULE_2__components_shared_AppointmentHistory_vue__["a" /* default */],
        HistoryAllergiesSection: __WEBPACK_IMPORTED_MODULE_3__components_shared_HistoryAllergiesSection_vue__["a" /* default */],
        HistoryMedAllergiesSection: __WEBPACK_IMPORTED_MODULE_4__components_shared_HistoryMedAllergiesSection_vue__["a" /* default */],
        HistoryDiseasesSection: __WEBPACK_IMPORTED_MODULE_5__components_shared_HistoryDiseasesSection_vue__["a" /* default */],
        HistoryChrondiseasesSection: __WEBPACK_IMPORTED_MODULE_6__components_shared_HistoryChrondiseasesSection_vue__["a" /* default */],
        HistoryVaccinesSection: __WEBPACK_IMPORTED_MODULE_7__components_shared_HistoryVaccinesSection_vue__["a" /* default */],
        HistoryMedicinesSection: __WEBPACK_IMPORTED_MODULE_8__components_shared_HistoryMedicinesSection_vue__["a" /* default */],
        HistoryFamilybackgroundsSection: __WEBPACK_IMPORTED_MODULE_9__components_shared_HistoryFamilybackgroundsSection_vue__["a" /* default */],
        HistoryObservationsSection: __WEBPACK_IMPORTED_MODULE_10__components_shared_HistoryObservationsSection_vue__["a" /* default */],
        HistoryEventsSection: __WEBPACK_IMPORTED_MODULE_11__components_shared_HistoryEventsSection_vue__["a" /* default */]
    },
    props: {},
    mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_clinicHistory_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_layout_mixin__["a" /* default */]],
    data: function data() {
        return {
            showGrantAccessHistoryModal: false,
            observations: null,
            expandSidebar: false,
            sidebarKey: 0,
            leftSideLiHeight: null,
            sideBarTrigger: {
                healthVars: 0,
                otherHealthVars: 0,
                diseases: 0,
                chronicDiseases: 0,
                pastMedication: 0,
                medication: 0,
                appointmentHistory: 0,
                observations: 0,
                significantEvents: 0,
                habits: 0,
                mood: 0,
                healthyHabits: 0,
                selfTest: 0,
                allergies: 0,
                medicationAllergies: 0,
                vaccines: 0,
                familyBackground: 0
            },
            grantAccess: {
                show: false
            },
            MENU_PATH: __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["P" /* MENU_PATH */]
        };
    },
    created: function created() {
        this.load();
        window.scrollTo(0, 0);
    },

    methods: {
        openHistorySection: function openHistorySection(section) {
            this.sideBarTrigger[section]++;
        },
        load: function load() {},
        refreshSidebar: function refreshSidebar() {
            this.sidebarKey++;
        }
    },
    computed: {
        showGrantHistoryAccess: function showGrantHistoryAccess() {
            return this.$store.getters['session/userIsPatient'] && this.$store.state.clinicHistory.sidebarHidden;
        },
        readOnlyView: function readOnlyView() {
            return !!this.$route.query.t;
        },
        sidebarDataRight: function sidebarDataRight() {
            var _this = this;
            return this.$store.state.session.user && this.$store.state.session.user.havePets ? {
                selectPatient: {
                    title: this.$t('clinic-history.select-patient'),
                    id: 'changeUser',
                    action: function action() {
                        _this.changeUserModalVisible = true;
                    }
                },
                selectPet: {
                    title: this.$t('clinic-history.select-pet'),
                    id: 'pet',
                    action: function action() {
                        _this.changePetModalVisible = true;
                    }
                },
                grantAccess: {
                    title: this.$t('clinic-history.grant-access'),
                    id: 'accessHistory',
                    action: function action() {
                        _this.grantAccess.show = true;
                    }
                },
                professionalsAuthorized: {
                    title: this.$t('clinic-history.access-authorizated'),
                    id: 'authorizedAccess',
                    action: function action() {
                        _this.showProfAndCenterAuthorizedModal = true;
                    }
                },
                back: {
                    title: this.$t('back'),
                    id: 'leftArrow',
                    action: function action() {
                        _this.goToSection(__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["P" /* MENU_PATH */]);
                    },

                    back: true,
                    hideHr: true
                }
            } : this.$store.getters['session/userIsProfessional'] || this.historyReadOnly ? {
                back: {
                    title: this.$t('back'),
                    id: 'leftArrow',
                    action: function action() {
                        _this.goToSection(__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["P" /* MENU_PATH */]);
                    },

                    back: true,
                    hideHr: true
                }
            } : {
                selectPatient: {
                    title: this.$t('clinic-history.select-patient'),
                    id: 'changeUser',
                    action: function action() {
                        _this.changeUserModalVisible = true;
                    }
                },
                grantAccess: {
                    title: this.$t('clinic-history.grant-access'),
                    id: 'accessHistory',
                    action: function action() {
                        _this.grantAccess.show = true;
                    }
                },
                professionalsAuthorized: {
                    title: this.$t('clinic-history.access-authorizated'),
                    id: 'authorizedAccess',
                    action: function action() {
                        _this.showProfAndCenterAuthorizedModal = true;
                    }
                },
                back: {
                    title: this.$t('back'),
                    id: 'leftArrow',
                    action: function action() {
                        _this.goToSection(__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["P" /* MENU_PATH */]);
                    },

                    back: true,
                    hideHr: true
                }
            };
        },
        sidebarData: function sidebarData() {
            return this.$route.query.petId ? {
                appointmentHistory: {
                    title: this.$t('appointmentsHistory'),
                    id: 'appointmentHistory'
                },
                diseases: {
                    title: this.$t('diseases'),
                    id: 'diseases'
                },
                medication: {
                    title: this.$t('currentMedication'),
                    id: 'medication'
                },
                pastMedication: {
                    title: this.$t('pastMedication'),
                    id: 'pastMedication'
                },
                medicationAllergies: {
                    title: this.$t('allergies'),
                    id: 'medicationAllergies'
                },
                allergies: {
                    title: this.$t('otherAllergies'),
                    id: 'allergies'
                },
                observations: {
                    title: this.$t('observations'),
                    id: 'observations'
                },
                vaccines: {
                    title: this.$t('vaccines'),
                    id: 'vaccines'
                }
            } : {
                appointmentHistory: {
                    title: this.$t('appointmentsHistory'),
                    id: 'appointmentHistory'
                },
                diseases: {
                    title: this.$t('diseases'),
                    id: 'diseases'
                },
                chronicDiseases: {
                    title: this.$t('chrondiseases'),
                    id: 'chronicDiseases'
                },
                medication: {
                    title: this.$t('currentMedication'),
                    id: 'medication'
                },
                pastMedication: {
                    title: this.$t('pastMedication'),
                    id: 'pastMedication'
                },
                medicationAllergies: {
                    title: this.$t('allergies'),
                    id: 'medicationAllergies'
                },
                allergies: {
                    title: this.$t('otherAllergies'),
                    id: 'allergies'
                },
                observations: {
                    title: this.$t('observations'),
                    id: 'observations'
                },
                significantEvents: {
                    title: this.$t('relvantsExperiences'),
                    id: 'significantEvents'
                },
                vaccines: {
                    title: this.$t('vaccines'),
                    id: 'vaccines'
                },
                familyBackground: {
                    title: this.$t('familyhistory'),
                    id: 'familyBackground',
                    hideHr: true
                }
            };
        }
    }
});

/***/ }),

/***/ 3507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseCard_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseTextarea__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//








var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseCard: __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseCard_vue__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton__["default"],
        BaseTextarea: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseTextarea__["default"]
    },
    props: {
        title: String
    },
    created: function created() {
        var _this = this;

        Object(__WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__["a" /* default */])().getObservations(this.observations).then(function (response) {
            if (response.data.data) {
                _this.observations = response.data.data;
            }
        });
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_5__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    data: function data() {
        return {
            observations: null
        };
    },

    methods: {
        saveObservations: function saveObservations() {
            var _this2 = this;

            var data = { value: this.observations };
            Object(__WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__["a" /* default */])().saveObservations(data).then(function (response) {
                if (response.data.data) {
                    _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
                }
            });
        }
    }
});

/***/ }),

/***/ 3508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseCard_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseTextarea__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//








var I18N_FILE = 'clinic-history';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseCard: __WEBPACK_IMPORTED_MODULE_0__components_base_ui_BaseCard_vue__["default"],
        BaseButton: __WEBPACK_IMPORTED_MODULE_1__components_base_buttons_BaseButton__["default"],
        BaseTextarea: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseTextarea__["default"]
    },
    props: {
        title: String
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_clinicHistory_mixin__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_5__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    created: function created() {
        var _this = this;

        Object(__WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__["a" /* default */])().getEvents(this.events).then(function (response) {
            if (response.data.data) {
                _this.events = response.data.data;
            }
        });
    },
    data: function data() {
        return {
            events: null
        };
    },

    methods: {
        saveEvents: function saveEvents() {
            var _this2 = this;

            var data = { value: this.events };
            Object(__WEBPACK_IMPORTED_MODULE_3__repositories_ClinicHistoryRepository__["a" /* default */])().saveEvents(data).then(function (response) {
                if (response.data.data) {
                    _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
                }
            });
        }
    }
});

/***/ }),

/***/ 4044:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2d07a6b4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0bef806d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryView.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0bef806d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClinicHistoryView.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4045:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-0bef806d]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-0bef806d],.slide-down-leave-active[data-v-0bef806d]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-0bef806d],.slide-down-leave-to[data-v-0bef806d]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-0bef806d],.slide-fade-left-leave-active[data-v-0bef806d]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-0bef806d],.slide-fade-left-leave-to[data-v-0bef806d]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-0bef806d]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-0bef806d],.fade-leave-to[data-v-0bef806d]{opacity:0\n}\n.history-container-inner-padding[data-v-0bef806d]{padding-left:2rem;padding-right:2rem\n}\n", ""]);

// exports


/***/ }),

/***/ 4046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryObservationsSection_vue__ = __webpack_require__(3507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6b4ffd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryObservationsSection_vue__ = __webpack_require__(4049);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4047)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6b4ffd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryObservationsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6b4ffd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryObservationsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryObservationsSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f6b4ffd8", Component.options)
  } else {
    hotAPI.reload("data-v-f6b4ffd8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4047:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4048);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b401e752", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6b4ffd8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryObservationsSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6b4ffd8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryObservationsSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4048:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-f6b4ffd8]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-f6b4ffd8],.slide-down-leave-active[data-v-f6b4ffd8]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-f6b4ffd8],.slide-down-leave-to[data-v-f6b4ffd8]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-f6b4ffd8],.slide-fade-left-leave-active[data-v-f6b4ffd8]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-f6b4ffd8],.slide-fade-left-leave-to[data-v-f6b4ffd8]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-f6b4ffd8]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-f6b4ffd8],.fade-leave-to[data-v-f6b4ffd8]{opacity:0\n}\n", ""]);

// exports


/***/ }),

/***/ 4049:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-textarea", {
        attrs: {
          placeholder: _vm.$t("observations-ph"),
          rows: 3,
          maxRows: 9,
          readOnly: _vm.historyReadOnly
        },
        model: {
          value: _vm.observations,
          callback: function($$v) {
            _vm.observations = $$v
          },
          expression: "observations"
        }
      }),
      _vm._v(" "),
      !_vm.historyReadOnly
        ? _c("base-button", { on: { click: _vm.saveObservations } }, [
            _vm._v(_vm._s(_vm.$t("save")))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6b4ffd8", esExports)
  }
}

/***/ }),

/***/ 4050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryEventsSection_vue__ = __webpack_require__(3508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ca77fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryEventsSection_vue__ = __webpack_require__(4053);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4051)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80ca77fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HistoryEventsSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80ca77fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HistoryEventsSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/shared/HistoryEventsSection.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-80ca77fc", Component.options)
  } else {
    hotAPI.reload("data-v-80ca77fc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4051:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("69e07d0c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-80ca77fc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryEventsSection.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-80ca77fc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HistoryEventsSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4052:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-80ca77fc]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-80ca77fc],.slide-down-leave-active[data-v-80ca77fc]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-80ca77fc],.slide-down-leave-to[data-v-80ca77fc]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-80ca77fc],.slide-fade-left-leave-active[data-v-80ca77fc]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-80ca77fc],.slide-fade-left-leave-to[data-v-80ca77fc]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-80ca77fc]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-80ca77fc],.fade-leave-to[data-v-80ca77fc]{opacity:0\n}\n", ""]);

// exports


/***/ }),

/***/ 4053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-textarea", {
        attrs: {
          placeholder: _vm.$t("observations-ph"),
          rows: 3,
          maxRows: 9,
          readOnly: _vm.historyReadOnly
        },
        model: {
          value: _vm.events,
          callback: function($$v) {
            _vm.events = $$v
          },
          expression: "events"
        }
      }),
      _vm._v(" "),
      !_vm.historyReadOnly
        ? _c("base-button", { on: { click: _vm.saveEvents } }, [
            _vm._v(_vm._s(_vm.$t("save")))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80ca77fc", esExports)
  }
}

/***/ }),

/***/ 4054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "history-view-container" } }, [
    _c(
      "div",
      {
        staticClass: "mb-4",
        class: {
          "history-container-inner-padding": !_vm.$store.state.clinicHistory
            .sidebarHidden
        },
        attrs: { id: "history-container" }
      },
      [
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.appointmentHistory.id,
              title: _vm.$t("appointmentsHistory"),
              sideBarTrigger: _vm.sideBarTrigger.appointmentHistory
            }
          },
          [_c("appointment-history")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.diseases.id,
              overflowVisible: "",
              title: _vm.$t("diseases"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.diseases
            }
          },
          [_c("history-diseases-section")],
          1
        ),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  id: _vm.sidebarData.chronicDiseases.id,
                  overflowVisible: "",
                  title: _vm.$t("chrondiseases"),
                  hideTitleOnOpen: "",
                  sideBarTrigger: _vm.sideBarTrigger.chronicDiseases
                }
              },
              [_c("history-chrondiseases-section")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.medication.id,
              overflowVisible: "",
              title: _vm.$t("currentMedication"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.medication
            }
          },
          [_c("history-medicines-section")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.pastMedication.id,
              overflowVisible: "",
              title: _vm.$t("pastMedication"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.pastMedication
            }
          },
          [_c("history-medicines-section", { attrs: { past: "" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.medicationAllergies.id,
              overflowVisible: "",
              title: _vm.$t("allergies"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.medicationAllergies
            }
          },
          [_c("history-med-allergies-section")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.allergies.id,
              overflowVisible: "",
              title: _vm.$t("otherAllergies"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.allergies
            }
          },
          [_c("history-allergies-section")],
          1
        ),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.observations.id,
              title: _vm.$t("observations"),
              sideBarTrigger: _vm.sideBarTrigger.observations
            }
          },
          [_c("history-observations-section")],
          1
        ),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  id: _vm.sidebarData.significantEvents.id,
                  title: _vm.$t("relvantsExperiences"),
                  sideBarTrigger: _vm.sideBarTrigger.significantEvents
                }
              },
              [_c("history-events-section")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "history-wrapper",
          {
            attrs: {
              id: _vm.sidebarData.vaccines.id,
              overflowVisible: "",
              title: _vm.$t("vaccines"),
              hideTitleOnOpen: "",
              sideBarTrigger: _vm.sideBarTrigger.vaccines
            }
          },
          [_c("history-vaccines-section")],
          1
        ),
        _vm._v(" "),
        !_vm.$route.query.petId
          ? _c(
              "history-wrapper",
              {
                attrs: {
                  id: _vm.sidebarData.familyBackground.id,
                  overflowVisible: "",
                  title: _vm.$t("familyhistory"),
                  hideTitleOnOpen: "",
                  sideBarTrigger: _vm.sideBarTrigger.familyBackground
                }
              },
              [_c("history-familybackgrounds-section")],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bef806d", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/47.bc4cbbac4e9b6282a925.js